var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L9.45765 3.31023V23.6864L0 20.3762V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.355 0L10.8973 3.30962V23.6858L19.6354 20.5829C19.0186 18.5144 19.224 16.6527 20.355 14.7903V0V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7946 12.929V0.103271L31.1495 3.41289V12.2051C28.2709 10.24 24.3646 10.55 21.7946 12.929Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9345 12.5152C30.3273 12.5152 33 15.2042 33 18.6178C33 21.3068 29.5045 26.4788 27.5513 29.5818C26.9345 30.409 26.4204 29.7884 26.3177 29.5818C24.4673 26.4788 20.8691 20.9968 20.8691 18.6178C20.8691 15.2042 23.5417 12.5152 26.9345 12.5152ZM26.9345 15.6182C28.4769 15.6182 29.8132 16.8593 29.8132 18.5145C29.8132 20.0662 28.4769 21.3074 26.9345 21.3074C25.3922 21.3074 24.0558 20.0662 24.0558 18.5145C24.0558 16.8593 25.3922 15.6182 26.9345 15.6182V15.6182Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapVertical);
export default __webpack_public_path__ + "static/media/map-vertical.ee1d33ffbc3e573118aa37f22460285e.svg";
export { ForwardRef as ReactComponent };